// extracted by mini-css-extract-plugin
export default {"container":"ema_2KL26","input":"ema_inp_1lSDI","phone":"ema_pho_C5Rsu"};